<script lang="ts" setup>
import InputMask, { type InputMaskEmits, type InputMaskProps } from 'primevue/inputmask'

interface Props extends /* @vue-ignore */ Omit<InputMaskProps, 'modelValue' | 'size' | 'fluid'> {
  modelValue?: string | null
  error?: boolean
  mask: InputMaskProps['mask']
}
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface Emits extends /* @vue-ignore */ InputMaskEmits {}

defineProps<Props>()
defineEmits<Emits>()

const model = defineModel<InputMaskProps['modelValue'] | null>()

const errorInjected = inject<Ref<boolean>>('error', ref(false))
</script>

<template>
  <InputMask
    v-bind="$props"
    v-model="model"
    fluid
    :size="$viewport.isLessThan('md') ? 'small' : undefined"
    :invalid="errorInjected || error"
  />
</template>
